module.exports = __webpack_public_path__ + "c0e5330c6ce039592472a4acf472291b.png";